import Header from './Header';
import Footer from './Footer';

const Layout = ({ children, className = '', transparentHeader = false }) => {
  return (
    <div className={`min-h-screen flex flex-col ${className}`}>
      <Header transparent={transparentHeader} />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
